import React, { Component } from 'react'
import { Link } from "react-router-dom";
import queryString from 'query-string'
import Auth from '../../Auth'
import { Loading } from './Loading'

import { setGrayBody } from './BodyBg'

const auth = new Auth();

export class WechatPay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            qrUrl: ''
        }
    }

    componentDidMount() {
        setGrayBody();
        const parsed = queryString.parse(window.location.search);
        console.log(parsed)

        if (!parsed.orderId)
            this.props.history.push("/")

        const options = {
            'headers': {
                ...auth.options()
            }
        }

        fetch('/api/Payment/GetWXPayRedirect?orderId=' + parsed.orderId, {
            ...options,
            method: 'GET'
        }).then(
            Response => {
                this.setState({ isLoading: false });

                if (Response.ok) {
                    return Response.json();
                }

                if (Response.status === 401) {
                    auth.signOut();
                    this.props.history.push("/Login")
                }

                if (Response.status === 404) {
                    this.props.history.goBack();
                }

                throw new Error('服务器错误');
            }

        ).then(
            (json) => {
                var imgUrl = "/api/Payment/QrImage?url=" + json.RedirectUrl;
                this.setState({ qrUrl: imgUrl })
            }
        ).catch(error => {
            console.error(error);
        });

        var orderStatusUrl = "/api/payment/GetOrderStatus?orderId=" + parsed.orderId;

        this.timer = setInterval(() => {
            fetch(orderStatusUrl, {
                ...options,
                method: 'GET'
            }).then(Response => Response.json()).then(json => {
                if (json.Status === 3) {
                    clearInterval(this.timer);
                    this.props.history.push('/Paid');
                }
            })
        }, 3000)
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        return (
            <div className="top pt-4">
                <div className="w-box p-5 text-center">
                    <div>
                        <div>
                            <img src={this.state.qrUrl} style={{ width: '188px' }} />
                        </div>
                        <div>
                            <p>打开微信，点击扫一扫支付金额</p>
                            <p>支付成功后如果长时间未跳转，请点击<Link to="/Paid">查看购买</Link></p>
                        </div>

                        <Loading isLoading={this.state.isLoading} />
                    </div>
                </div>

            </div>
        )
    }
}

export default WechatPay